import { render, staticRenderFns } from "./OnboardingModal.vue?vue&type=template&id=07d83e24&scoped=true&"
import script from "./OnboardingModal.vue?vue&type=script&lang=js&"
export * from "./OnboardingModal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingModal.vue?vue&type=style&index=0&id=07d83e24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d83e24",
  null
  
)

export default component.exports